import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagingAdminComponent } from './messaging-admin/messaging-admin.component';
import { AppPropertiesService, AppPropertyComponentsModule, CommonLayoutModule, CommonUIModule } from '@sdbn/common';



@NgModule({
  declarations: [
    MessagingAdminComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    AppPropertyComponentsModule,
    CommonUIModule
  ]
})
export class MessagingAdminModule {

  constructor(
    private appPropertiesService: AppPropertiesService
  ) {

    appPropertiesService.registerAppPropertiesAdminComponent('tmc-yard.messaging.ui.messaging-properties-admin.tab-title', MessagingAdminComponent);
  }
}
